__turbopack_context__.v({
  "description": "tabsSlider-module-scss-module__RV834W__description",
  "dot": "tabsSlider-module-scss-module__RV834W__dot",
  "dotButton": "tabsSlider-module-scss-module__RV834W__dotButton",
  "dotNumber": "tabsSlider-module-scss-module__RV834W__dotNumber",
  "dotText": "tabsSlider-module-scss-module__RV834W__dotText",
  "dotsList": "tabsSlider-module-scss-module__RV834W__dotsList",
  "dotsWrapper": "tabsSlider-module-scss-module__RV834W__dotsWrapper",
  "iconWrapper": "tabsSlider-module-scss-module__RV834W__iconWrapper",
  "img": "tabsSlider-module-scss-module__RV834W__img",
  "imgLabel": "tabsSlider-module-scss-module__RV834W__imgLabel",
  "slideContainer": "tabsSlider-module-scss-module__RV834W__slideContainer",
  "slideText": "tabsSlider-module-scss-module__RV834W__slideText",
  "slider": "tabsSlider-module-scss-module__RV834W__slider",
  "slidersWrapper": "tabsSlider-module-scss-module__RV834W__slidersWrapper",
  "slidersWrapperIsReversed": "tabsSlider-module-scss-module__RV834W__slidersWrapperIsReversed",
  "slidersWrapperWithDotsDescription": "tabsSlider-module-scss-module__RV834W__slidersWrapperWithDotsDescription",
  "swiperPaginationBulletActive": "tabsSlider-module-scss-module__RV834W__swiperPaginationBulletActive",
  "title": "tabsSlider-module-scss-module__RV834W__title",
});
